import { Platform } from 'react-native';
// I could not import isAndroid, isWeb.. from core !!

export * from './config';
export * from './theme';
export * from './countries';

export const APP_TABS = { SETTINGS: 'SETTINGS', GROUPS: 'GROUPS', PM: 'PM' };
export const SETTINGS_ITEMS = {
  ACCOUNT: 'ACCOUNT',
  SUPPORT: 'SUPPORT',
  SUGGESTIONS: 'SUGGESTIONS',
  DEVICES: 'DEVICES'
};
export const GROUP_TABS = {
  CHAT: 'CHAT',
  TASKS: 'TASKS',
  MATERIAL: 'MATERIAL',
  INFO: 'INFO'
};

export const PAGE_SIZE = 30;

export const PENDING = 'PENDING';
export const LOADING = 'LOADING';
export const CANCELED = 'CANCELED';
export const SUCCESS = 'SUCCESS';
export const FAIL = 'FAIL';
export const FINISHED = 'FINISHED';
export const MODALS = {
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  JOIN_GROUP: 'JOIN_GROUP',
  NEW_GROUP: 'NEW_GROUP',
  ALTER_GROUP: 'ALTER_GROUP',
  ADD_TASK: 'ADD_TASK',
  EDIT_TASK: 'EDIT_TASK',
  CONTACTS_LIST: 'CONTACTS_LIST',
  CONTACT_PROFILE: 'CONTACT_PROFILE',
  REMOVE_MEMBER: 'REMOVE_MEMBER',
  MAP: 'MAP',
  BLOCK_LIST: 'BLOCK_LIST',
  EDIT_GROUP: 'EDIT_GROUP',
  CHANGE_NAME: 'CHANGE_NAME',
  SUBMISSIONS: 'SUBMISSIONS'
};

export const SESSIONS = {
  ALL: 'ALL',
  CURRENT: 'CURRENT'
};

export const CONV_TYPE = {
  GROUP: 'GROUP',
  PM: 'PM'
};

export const GROUP_ROLES = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  CREATOR: 'CREATOR',
  LEFT: 'LEFT',
  REMOVED: 'REMOVED',
  BLOCKED: 'BLOCKED'
};

export const GROUP_ROLES_WEIGHT = {
  [GROUP_ROLES.ADMIN]: 100,
  [GROUP_ROLES.CREATOR]: 80,
  [GROUP_ROLES.MEMBER]: 10,
  [GROUP_ROLES.LEFT]: -10,
  [GROUP_ROLES.REMOVED]: -20,
  [GROUP_ROLES.BLOCKED]: -30
};

export const SYS_MSG = {
  GROUP_CREATED: 'GROUP_CREATED',
  GROUP_UPDATED: 'GROUP_UPDATED',
  GROUP_CLOSED: 'GROUP_CLOSED',
  GROUP_OPENED: 'GROUP_OPENED',
  USER_JOINED: 'USER_JOINED',
  USER_REJOINED: 'USER_REJOINED',
  USER_LEFT: 'USER_LEFT',
  MAKE_ADMIN: 'MAKE_ADMIN',
  UNMAKE_ADMIN: 'UNMAKE_ADMIN',
  ADD_MATERIAL: 'ADD_MATERIAL',
  REMOVE_MATERIAL: 'REMOVE_MATERIAL',
  UPDATE_MATERIAL: 'UPDATE_MATERIAL',
  ADD_TASK: 'ADD_TASK',
  UPDATE_TASK: 'UPDATE_TASK',
  REMOVE_TASK: 'REMOVE_TASK',
  MEMBER_BLOCKED: 'MEMBER_BLOCKED',
  MEMBER_UNBLOCKED: 'MEMBER_UNBLOCKED',
  MEMBER_REMOVED: 'MEMBER_REMOVED',
  GROUP_AVATAR_CHANGED: 'GROUP_AVATAR_CHANGED'
};

export const USER_MSG_TYPES = {
  CONTACT: 'CONTACT',
  LOCATION: 'LOCATION',
  TEXT: 'TEXT',
  PARSED: 'PARSED',
  DELETED: 'DELETED',
  UPLOAD: 'UPLOAD',
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO'
};

export const MEMBER_COLOR = [
  '#b71c1c',
  '#880E4F',
  '#6A1B9A',
  '#651FFF',
  '#1A237E',
  '#1565C0',
  '#01579B',
  '#006064',
  '#004D40',
  '#2E7D32',
  '#33691E',
  '#9E9D24',
  '#BE6473',
  '#F58C82',
  '#F5D778',
  '#5A5578',
  '#A0C1A5',
  '#5D4037',
  '#035472',
  '#BC8A69'
];

export const REPORT_TYPE = {
  SEXUAL_CONTENT: 'SEXUAL_CONTENT',
  VIOLENT_CONTENT: 'VIOLENT_CONTENT',
  SPAM: 'SPAM'
};

export const IMAGE_SIZE = {
  TINY: 16,
  SMALL: 64,
  MEDIUM: 256,
  LARGE: 1024
};

export const NOTIFICATION_CHANNEL = {
  CHAT_MESSAGES: 'CHAT_MESSAGES'
};

export const IPHONEX_PADDING = { paddingTop: 30, paddingBottom: 30 };



// WEBPACK FOOTER //
// ./src/constants/constants.js